import { useState } from 'react';

export interface UseCheckOnFocusResult {
    isOnFocus: boolean;
    handleFocus(): void;
    handleBlur(): void;
}

export function useCheckOnFocus(): UseCheckOnFocusResult {
    const [isOnFocus, setIsOnFocus] = useState(false);

    const handleFocus = () => setIsOnFocus(true);
    const handleBlur = () => setIsOnFocus(false);

    return { isOnFocus, handleFocus, handleBlur };
}
